<script setup lang="ts">
import { computed } from "vue"

const props = defineProps({
  field: { type: String, required: true },
  type: { type: String, required: true },
  modelValue: { type: [String, Number, Date, null], required: true },
  label: { type: String, default: "" },
  guide: { type: String, default: "" },
  giveLabelBlankMargin: { type: Boolean, default: false },
  placeholder: { type: String, default: "" },
  prefix: String,
  suffix: String,
  min: { type: [String, Number] },
  max: { type: [String, Number] },
  step: Number,
  required: Boolean,
  disabled: Boolean,
  suppressRequiredMark: { type: Boolean, default: false },
})
const emits = defineEmits(["update:modelValue"])

// proxy for v-model binding
const internalValue = computed({
  get: () => props.modelValue,
  set: (v) => emits("update:modelValue", v),
})
</script>

<template>
  <div class="input-box">
    <label v-if="label" class="form-label" :for="field"
      >{{ label }} <span class="text-danger" v-if="required && !suppressRequiredMark">*</span></label
    >
    <div v-if="guide" class="input-guide">
      <small
        ><em>{{ guide }}</em></small
      >
    </div>

    <input
      v-if="!prefix && !suffix"
      class="form-control"
      :class="{ labelBlankMargin: !label && giveLabelBlankMargin }"
      :type="type"
      :id="field"
      :name="field"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :step="step"
      :required="required"
      :disabled="disabled"
      v-model="internalValue"
    />

    <div v-else class="input-group" :class="{ labelBlankMargin: !label && giveLabelBlankMargin }">
      <span v-if="prefix" class="input-group-text" :id="`${field}-text`">{{ prefix }}</span>
      <input
        class="form-control"
        :type="type"
        :id="field"
        :name="field"
        :placeholder="placeholder"
        :min="min"
        :max="max"
        :step="step"
        :required="required"
        :disabled="disabled"
        :aria-describedby="`${field}-text`"
        v-model="internalValue"
      />
      <span v-if="suffix" class="input-group-text" :id="`${field}-text`">{{ suffix }}</span>
    </div>
  </div>
</template>

<style scoped>
.form-label {
  font-weight: 600;
}

.input-guide {
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
}

.labelBlankMargin {
  margin-top: 24.8px;
}
</style>
